export enum OnboardingType {
    STARTED = 'started',
    ONBOARD_FLOW = 'onboard-flow',
    FAQ = 'faq',
    LOGIN_FLOW = 'login-flow',
    LOGIN_PAGE = 'login-page',
    COMPLETED = 'completed'
}
